import React, { useContext, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import config from '../config';
import Logo from './Logo';

const Navbar = () => {
  const { t, language, changeLanguage } = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-nav">
      <div className="site-nav__inner">
        <Link to="/" className="site-nav__brand" onClick={close}>
          <Logo className="logo--nav" />
          <span>{config.name}</span>
        </Link>

        <button
          className="site-nav__toggle"
          aria-label="Menu"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span /><span /><span />
        </button>

        <nav className={`site-nav__menu ${open ? 'is-open' : ''}`}>
          <NavLink to="/" end onClick={close}>{t.nav.home}</NavLink>
          <NavLink to="/projets" onClick={close}>{t.nav.projects}</NavLink>
          <NavLink to="/about" onClick={close}>{t.nav.about}</NavLink>
          <NavLink to="/contact" onClick={close}>{t.nav.contact}</NavLink>
          <div className="site-nav__lang">
            <button className={language === 'fr' ? 'is-active' : ''} onClick={() => changeLanguage('fr')}>FR</button>
            <span>/</span>
            <button className={language === 'en' ? 'is-active' : ''} onClick={() => changeLanguage('en')}>EN</button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
